import React from 'react'

const Bus = () => {
  return (
    <div>Bus</div>
  )
}

export default Bus